<template>
   <section class="indicators">
     <b-row>
        <b-col cols="12">
                    <span class="dot dot-1 half-complete">
                    </span>
                    <span class="dot-label">Has shipping Id but no label</span>
                     <span class="dot dot-1 ">
                    </span>
                    <span class="dot-label">Has shipping Id & label</span>
                    <span class="dot dot-2"></span>
                    <span class="dot-label">Closeout done</span>
                    <span class="dot dot-3"></span>
                    <span class="dot-label">Added for pickup</span>
        </b-col>
      </b-row>
   </section>
</template>

<script>
  export default {
    
  }
</script>

<style lang="scss" scoped>
    .indicators{
       background-color: rgb(42, 51, 61);
       padding: 5px;
       border-radius: 5px 5px 0 0;
    }
    .dot{
        width: 10px;
        height: 10px;
        display: inline-block;
        border-radius: 50%;
        background-color: rgb(233, 233, 233);
        margin-right: 5px;
      }
      .dot-1{
        background-color:#FF9034;
        position: relative;
      }
      .dot-1.half-complete::after{
        position: absolute;
        content: '';
        width: 5px;
        height: 10px;
        right: 0px;
        top: 0px;
        border-radius: 0 5px 5px 0;
        background-color:#fff;
        display: block;
      }
      .dot-2{
        background-color:#34D633;
      }
      .dot-3{
        background-color:#8D3ABC;
      }
      .dot-label{
        font-size: 13px;
        padding-right: 20px
      }
</style>